const FETCH_LIMIT = 15;
const BASE_URL = 'https://chatty.doodle-test.com';
const ENDPOINTS = '/api/chatty/v1.0/';

const DEFAULT_AUTHOR = 'Anonymous';
const API_TOKEN = 'FGvviHC9KSai';
const BEGIN_SINCE = 1637869064412;

export {
  FETCH_LIMIT,
  DEFAULT_AUTHOR,
  API_TOKEN,
  BASE_URL,
  ENDPOINTS,
  BEGIN_SINCE,
};
